export const SHOPPING_AIDS = [
    {
      item: 'Jewelry Trays',
      itemImageDesktop: '/images/packaging/shoppingAids/desktop/jewelryTrays.webp',
      //itemImageMobile: '/images/packaging/shoppingAids/mobile/jewelryTrays.webp',
       path: '/packaging/shopping-aids/jewelryTrays',
    },
    {
      item: 'Mirror',
      itemImageDesktop: '/images/packaging/shoppingAids/desktop/mirror.webp',
      //itemImageMobile: '/images/packaging/shoppingAids/mobile/mirror.webp',
       path: '/packaging/shopping-aids/mirror',
    },
    {
      item: 'Tissue Boxes',
      itemImageDesktop: '/images/packaging/shoppingAids/desktop/tissueBoxes.webp',
      //itemImageMobile: '/images/packaging/shoppingAids/mobile/tissueBoxes.webp',
       path: '/packaging/shopping-aids/tissueBoxes',
    },
  ]